import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturesComponent } from './features.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { RouterModule, Routes } from '@angular/router';
import { NbMenuItem } from '@nebular/theme';
import { FeatureTypesComponent } from './feature-types/feature-types.component';
import { FeatureGroupsComponent } from './feature-groups/feature-groups.component';
import { FeatureComponent } from './feature/feature.component';
//link:"/admin/features/feature-category/"+productFeatureCategoryId+"/features"
export const featuresroutes: Routes = [
  {
    path:'',
    component:FeaturesComponent,
    children:[
      {
        path:'feature-category/:productFeatureCategoryId',
        component:FeaturesComponent
      },
      {
        path:'feature-category/:productFeatureCategoryId/features',
        component:FeaturesComponent
      }
    ]
  },
  {
    path:'feature',
    component:FeatureComponent,
    children:[
      {
        path:"new",
        component:FeatureComponent,
      }
    ]
  },
  {
    path:'feature-groups',
    component:FeatureGroupsComponent,
    children:[
      {
        path:'new',
        component:FeatureGroupsComponent,
      }
    ]
  },
  {
    path:'feature-types',
    component:FeatureTypesComponent,
    children:[
      {
        path:"new",
        component:FeatureTypesComponent
      }
    ]
  }


]



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(featuresroutes),
    UbsViewContainersModule
  ]
})
export class FeaturesRoutingModule { 
  MENU_ITEMS:NbMenuItem[] = [];
  headerTitle:string = "Product Features";
  path:string = "features";
  menuTag:string = "featuresMenu"
  menuAndTitleOptions = {path:this.path,menuItems:this.MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};

  constructor(private viewContainerService:ViewContainersService){
    console.log("UpdateMenuTitle",this.menuAndTitleOptions)
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(this.menuTag);
  }
}
